import { Boton, InputDate, Label, Spinner } from 'asocomponents'
import React, { useEffect, useState } from 'react'
import BuscadorJuicios from '../Buscadores/BuscadorJuicios/BuscadorJuicios'
import { mostrarMensaje, useMostrarMensajeConfirmacion } from '../../../helpers/mensajeria'
import { useNavigate } from 'react-router-dom'
import GrillaDetallePagos from './GrillaDetallePagos'
import { setPagoSinFactura, resetPagoSinFactura } from "../../../redux/datosPagoSinFacturaSlice"
import { useDispatch, useSelector } from 'react-redux'
import PagosSinFacturaService from '../../../../modules/Liquidacion/application/PagosSinFacturaService'
import ModalAgregarPago from './ModalAgregarPago'
import { formatearNumero } from '../../../helpers/funciones'
import { formatearFechaLuxon } from '../../../../modules/utils/formatearFecha'
import { MENSAJESAPP } from "../../../const/constantes.js";

export default function FormularioAltaPagoSinFactura() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const mostrarMensajeConfirmacion = useMostrarMensajeConfirmacion()
    const pagoSinFactura = useSelector((state) => state.rootReducer.datosPagoSinFactura.pagoSinFactura)
    const pagosLiq = useSelector(state => state.rootReducer.datosPagoSinFactura.pagoSinFactura.pagos);

    const idLiquidacionWebSinFactura = useSelector(state => state.rootReducer.datosPagoSinFactura.idLiquidacionWebSinFactura)

    const usuarioString = sessionStorage.getItem("usuario") && JSON.parse(sessionStorage.getItem("usuario"))
    const cuit = usuarioString.usuario

    const [isOpen, setIsOpen] = useState(false)
    const [modalOpen, setModalOpen] = useState(false);

    const [idJuicio, setIdJuicio] = useState(null)
    const [caratula, setCaratula] = useState(null)
    const [idDenuncia, setIdDenuncia] = useState(null)
    const [importeTotal, setImporteTotal] = useState(null)


    const [caratulaJuicio, setCaratulaJuicio] = useState(null)
    const [fechaVto, setFechaVto] = useState(null)

    const [estadoFactura, setEstadoFactura] = useState(null)

    const [isLoading, setIsLoading] = useState(false)
    const [idJuicioValido, setIdJuicioValido] = useState(false)
    const [fechaVtoValido, setFechaVtoValido] = useState(false)

    const [resetKey, setResetKey] = useState(0);

    const formValido = fechaVtoValido && idJuicioValido && (pagosLiq.length > 0)

    const redireccionar = () => {
        dispatch(resetPagoSinFactura())
        navigate("/pagossinfactura")
    }

    const cargarInfoPagoSinFactura = async () => {
        setIsOpen(true)
        const pagoServices = new PagosSinFacturaService()
        const pagoObtenido = await pagoServices.getListPagos(idLiquidacionWebSinFactura, undefined, undefined, undefined, undefined, undefined, undefined, undefined, cuit)
        const detallePagoObtenido = await pagoServices.getDetallePago(idLiquidacionWebSinFactura)

        if (pagoObtenido) {
            const pago = pagoObtenido[0]
            setFechaVto(formatearFechaLuxon(pago.fechaVto, 'yyyy-MM-dd'))
            setCaratulaJuicio(pago.procesoJudicial)
            setIdJuicio(pago.idJuicio)
            setImporteTotal(pago.importe)

            dispatch(setPagoSinFactura({ ...pagoSinFactura, pagos: detallePagoObtenido }))

            setIdJuicioValido(true)
            setFechaVtoValido(true)
        }

        setIsOpen(false)
    }

    const guardarPagoSinFactura = async () => {
        try {
            const pagoSinFacturaService = new PagosSinFacturaService()

            const resultadoAltaPago = await pagoSinFacturaService.altaPagoSinFactura(pagoSinFactura)

            if (resultadoAltaPago.message !== "OK")
                return false
            else
                return true
        }
        catch (e) {
            return false
        }
    }

    const handleJuicio = async (juicio) => {
        if (juicio) {
            setIdJuicio(juicio.idJuicio)
            setCaratula(juicio.caratula)
            setIdDenuncia(juicio.idDenuncia)
            setIdJuicioValido(true)

            dispatch(setPagoSinFactura({
                ...pagoSinFactura,
                cuitLetrado: cuit,
                idUsuarioAlta: usuarioString.idusuario,
                idJuicio: juicio.idJuicio,
                idDenuncia: juicio.idDenuncia
            }))
        }
        else
            setIdJuicioValido(false)
    }

    const limpiarForm = () => {
        setIdJuicio('')
        setFechaVto('')
        setCaratula('')
        setFechaVtoValido(false)
        setIdJuicioValido(false)
        dispatch(resetPagoSinFactura())
    }
    const handleSubmit = async (event) => {
        event.preventDefault()
        setIsLoading(true)

        const rdo = await guardarPagoSinFactura()

        if (!rdo) {
            mostrarMensaje(MENSAJESAPP.ERRORES.PAGOCONERROR, "error", 3000)
        }
        else {
            limpiarForm()
            mostrarMensaje("Se grabó el pago correctamente", "success", 3000)
            dispatch(resetPagoSinFactura())
        }

        setIsLoading(false)
    }

    const handleFechaVto = (fecha) => {
        if (fecha !== "") {
            if (Date.parse(fecha) <= Date.now()) {
                setFechaVto("")
                setResetKey(prev => prev + 1)
                setFechaVtoValido(false)
                mostrarMensaje(MENSAJESAPP.VALIDACIONES.FECHAPAGO, "error", 2000)
            } else {
                setFechaVtoValido(true)
                setFechaVto(fecha)
                dispatch(setPagoSinFactura({
                    ...pagoSinFactura,
                    fechaVto: fecha
                }))
            }
        }
    }

    const handleCancelar = () => {
        mostrarMensajeConfirmacion(MENSAJESAPP.CONFIRMACION.CANCELARCARGA, redireccionar, "info")
    }

    const handleVolver = () => {
        redireccionar()
    }

    useEffect(() => {
        const importeTotal = pagosLiq.reduce((suma, item) => suma + item.importeTotal, 0)
        setImporteTotal(importeTotal)

        dispatch(setPagoSinFactura({
            ...pagoSinFactura,
            importeTotal: importeTotal
        }))

    }, [pagosLiq])

    useEffect(() => {
        idLiquidacionWebSinFactura && cargarInfoPagoSinFactura()
    }, [])

    return (
        <>
            <div className={`overlay ${isOpen ? "open" : ""}`}></div>
            <div className="flex flex-col justify-center items-center mt-5">
                <div className="border-asociart-blue w-[800px] shadow-lg">
                    <div className="flex flex-row justify-left items-left mt-5 ml-10">
                        <Label texto="Seleccione un Proceso Judicial:" />
                        {!caratulaJuicio ?
                            <>
                                <div className="flex items-center gap-2">
                                    <div className="w-42">
                                        <BuscadorJuicios
                                            onChange={handleJuicio}
                                            cuitLetrado={cuit}
                                            width="w-16"
                                            valor={idJuicio}
                                            referente="judicial"
                                        />
                                    </div>
                                    {!idJuicioValido && (
                                        <Label texto="(*)" color="text-asociart-custom" />
                                    )}
                                    <div className="w-[300px] overflow-hidden text-ellipsis whitespace-nowrap">
                                        {caratula && <Label texto={`${caratula.slice(0, 40)}...`} color="text-gray-600" />}
                                    </div>
                                </div>

                            </>
                            : <Label texto={caratulaJuicio} color="text-gray-600" />
                        }
                    </div>

                    <div className="flex flex-row justify-left items-left mt-5 ml-10">
                        <Label texto="Fecha de Vencimiento:" />
                        <InputDate width='w-40' onChange={handleFechaVto} valor={fechaVto} key={resetKey} disabled={idLiquidacionWebSinFactura ? "true" : "false"} disabledSabDom = {true}/>{!fechaVtoValido && <Label texto="(*)" color="text-asociart-custom" />}
                    </div>
                    <div className="mt-3">
                        <hr />
                    </div>
                    {!idLiquidacionWebSinFactura &&
                        <div className="flex flex-row justify-end items-right mt-5 mr-5">
                            <Boton
                                texto="Agregar Pago"
                                icono="add"
                                fondo="rojo"
                                height="h-7" onClick={() => setModalOpen(true)} />
                            <ModalAgregarPago
                                isOpen={modalOpen}
                                onClose={() => setModalOpen(false)}
                            />
                        </div>
                    }

                    <div className="flex flex-row justify-start items-right mt-5 mr-5">
                        <GrillaDetallePagos idLiquidacionWebSinFactura={idLiquidacionWebSinFactura} />
                    </div>

                    <div className="flex flex-row justify-start items-right ml-10">
                        <Label texto={`IMPORTE TOTAL: $ ${formatearNumero(String(importeTotal))}`} />
                    </div>

                    {!idLiquidacionWebSinFactura &&
                        <div className="flex justify-between items-center w-full px-10 mt-5 mb-5">
                            <div className="flex-1 flex justify-end align-middle w-[55%]">
                                {isLoading ? (
                                    <Spinner color="red" size="20" />
                                ) : (
                                    <Boton
                                        texto="Enviar"
                                        fondo={formValido ? "rojo" : "gris"}
                                        onClick={handleSubmit}
                                        disabled={!formValido}
                                    />
                                )}
                            </div>

                            {/* Botón Cancelar a la derecha */}
                            <div className="flex justify-end align-middle w-[45%]">
                                <Boton
                                    texto="Cancelar carga"
                                    height="h-7"
                                    onClick={handleCancelar}
                                    fondo="gris"
                                />
                            </div>
                        </div>
                    }
                    {idLiquidacionWebSinFactura &&
                        <div className="flex justify-between items-center w-full px-10 mt-5 mb-5">
                            <div className="flex-1 flex justify-center align-middle">

                                <Boton
                                    texto="Volver"
                                    fondo="rojo"
                                    onClick={handleVolver}
                                />

                            </div>
                        </div>
                    }
                    {!estadoFactura &&
                        <div className="flex flex-row justify-end items-center m-5 text-sm">
                            <Label texto="(*) Campos obligatorios" color="text-asociart-custom" />
                        </div>
                    }
                    <div className="flex flex-row justify-start items-center m-5 text-xs">
                        Ante cualquier duda, comunicarse con su referente judicial de referencia según corresponda.
                    </div>
                </div>
            </div >
        </>
    )
}
